<template>
  <div class="lobby">
    <div class="lobby__box-wrapper">
      <avl-box class="lobby__box">
        <div class="lobby__row">
          <avl-section-separator label="Create Game"></avl-section-separator>
        </div>

        <div class="lobby__row">
          <div class="lobby__col">
            <el-button
              class="lobby__button"
              @click.native="onCreateGame(false)"
              v-tooltip="'The game will be<br> visible in the lobby'"
            >
              Public
            </el-button>
          </div>

          <div class="lobby__col">
            <el-button
              class="lobby__button"
              @click.native="onCreateGame(true)"
              v-tooltip="'The game will NOT be<br> visible in the lobby'"
            >
              Private
            </el-button>
          </div>
        </div>

        <div class="lobby__row">
          <avl-section-separator label="Join Game"></avl-section-separator>
        </div>

        <div class="lobby__row lobby__row--more-margin">
          <div class="lobby__col">
            <label for="pinCode">Pin-code</label>
            <el-input
              id="pinCode"
              v-model="pinCode"
              label="Pin-code"
              placeholder="ex: fm2r"
            ></el-input>
          </div>

          <div class="lobby__col">
            <el-button
              class="lobby__button"
              @click.native="onJoinGameByPinCode"
              :disabled="!pinCode"
            >
              Join Game
            </el-button>
          </div>
        </div>
      </avl-box>

      <div class="lobby__games-list-wrapper">
        <avl-games-list
          class="lobby__games-list"
          :games="getGames"
          :totalGames="getTotalGames"
        ></avl-games-list>
      </div>
    </div>

    <avl-chat
      title="Lobby"
      :messages-list="getMessages"
      :participants="getRoomUsers"
      @sendMessage="
        $store.dispatch('chat/sendMessage', {
          roomId: 'lobby',
          message: $event,
        })
      "
    ></avl-chat>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import GamesList from './games-list';
  import SectionSeparator from './section-separator';

  export default {
    data: () => ({
      pinCode: null,
    }),
    computed: {
      ...mapGetters('socket', ['getRoomUsers']),
      ...mapGetters('chat', ['getMessages']),
      ...mapGetters('lobby', ['getGames', 'getTotalGames']),
    },
    methods: {
      onCreateGame(isPrivate) {
        this.$store.dispatch('lobby/createGame', isPrivate);
      },
      onJoinGameByPinCode() {
        this.$store.dispatch('lobby/joinGameByPinCode', this.pinCode.trim().toLowerCase());
      },
    },
    async beforeRouteLeave(to, from, next) {
      await this.$store.dispatch('lobby/leaveRoom', { roomId: 'lobby' });

      next();
    },
    components: {
      'avl-games-list': GamesList,
      'avl-section-separator': SectionSeparator,
    },
  };
</script>

<style scoped lang="scss">
  .lobby {
    &__box-wrapper {
      width: 300px;
      //
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &__box {
      margin-bottom: 12px;
    }

    &__row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 24px;

      &:last-child {
        margin-bottom: 0;
      }

      &--more-margin {
        margin-bottom: 32px;
      }
    }

    &__button {
      width: 100%;
    }

    &__col {
      display: inline-block;
      vertical-align: middle;
      width: calc(50% - 8px);
      align-self: flex-end;
      position: relative;
    }

    &__games-list-wrapper {
      position: relative;
    }

    &__games-list {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%);
    }
  }
</style>
